import { EMAIL_MANAGEMENT_TABLE_COLUMNS } from '../constants/email-management-table.constants'

const formatEmailManagementDate = (dateString) => {
  if (!dateString) return ''

  try {
    const date = new Date(dateString)

    const options = {
      timeZone: 'Europe/Madrid',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    }

    const madridDate = new Date(date.toLocaleString('en-US', { timeZone: 'Europe/Madrid' }))

    const day = madridDate.getDate()
    const month = madridDate.getMonth() + 1
    const year = madridDate.getFullYear()
    const hours = madridDate.getHours().toString().padStart(2, '0')
    const minutes = madridDate.getMinutes().toString().padStart(2, '0')
    const seconds = madridDate.getSeconds().toString().padStart(2, '0')

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`
  } catch (error) {
    console.warn('Error formateando fecha email-management:', dateString)
    return ''
  }
}

export const emailManagementDataPreparation = ({ data, intl }) => {
  if (!Array.isArray(data)) {
    return []
  }

  return data.map((item) => {
    if (!item || typeof item !== 'object') {
      return {
        id: null,
        email: '',
        tipo: '',
        isInBlacklist: false,
        isInWhitelist: false,
      }
    }

    const formattedDates = {}

    EMAIL_MANAGEMENT_TABLE_COLUMNS.forEach((column) => {
      if (column.type === 'date' && item[column.field]) {
        formattedDates[column.field] = formatEmailManagementDate(item[column.field])
      }
    })

    return {
      ...item,
      ...formattedDates,
      id: item.id ?? null,
      email: item.email ?? '',
      tipo: item.tipo ?? '',
      isInBlacklist: item.isInBlacklist ?? false,
      isInWhitelist: item.isInWhitelist ?? false,
      motive: item.motive ?? '',
      tableData: {
        ...item.tableData,
      },
    }
  })
}
